/*
 * 1-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * App.tsx - Entry point for app.
 */

import { useFonts } from 'expo-font';
import Navigation from './navigation';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import useSettingsStore from './hooks/useSettingsStore';
import * as SplashScreen from 'expo-splash-screen';
import { SystemBars } from 'react-native-edge-to-edge';

// Don't hide the splash screen until we say so, as we might be loading fonts or other things.
SplashScreen.preventAutoHideAsync();
SplashScreen.setOptions({
  duration: 500,
  fade: true
});

const App = () => {
  const [fontsLoaded] = useFonts({
    WhiteRoseMathsFont: require('./assets/fonts/White_Rose_Noto_regular.ttf'),
  });

  const settingsStoreHasHydrated = useSettingsStore(settings => settings._hasHydrated);

  if (!fontsLoaded || !settingsStoreHasHydrated) {
    return null;
  }

  return (
    <SafeAreaProvider>
      <Navigation onReady={SplashScreen.hide}/>
      <SystemBars style='light' />
    </SafeAreaProvider>
  );
};

export default App;
